<template>
    <BModal v-model="isOpen" size="md" centered hide-footer hide-header>
        <UserDetails group-code="contact"/>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import Errors from '../../utils/errors';
import UserDetails from '../users/UserDetails';

export default {
  data() {
    return {
      errors: new Errors(),
    };
  },
  components: {
    UserDetails,
    BModal,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.users.isUserModalOpen;
      },
      set(val) {
        this.$store.dispatch('users/clearCurrentUser');
        this.$store.commit('users/isUserModalOpen', val);
      },
    },
  },
};
</script>
